import React from 'react';
import { TeacherCardsContainer, TeacherCard, TeacherImage, TeacherTitle, TeacherImageContainer } from './TeacherCardsStyle';
import { getTeacherCardDetails } from '../../helpers/teacherCardHelper';
import { APP_CONSTANTS, defaultColor } from '../../constants';
import { useContext } from 'react';
import { InformationContext } from 'src/consumer/context/InformationContext';
import { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { HorizontalScrollLeftButton, HorizontalScrollRightButton } from '../CardList/CardListStyle';
import { getImageLink } from 'src/mentor/helpers/utilityFunctions';

export const renderCardsList = (props, setInformationModalData) => {
    const { cardsData } = props;

    return cardsData?.map((card, index) => {
        const { teacherTitle, teacherImage } = getTeacherCardDetails(card);
        return (
            <TeacherCard bgColor={defaultColor} key={index} onClick={() => {
                setInformationModalData({ showModal: true, data: { toShow: "app_exclusive" } })
            }}>

                <TeacherImageContainer>
                    <TeacherImage src={getImageLink(teacherImage)} />
                </TeacherImageContainer>

                <TeacherTitle>
                    {teacherTitle}
                </TeacherTitle>

            </TeacherCard>
        )
    })
}

const TeacherCards = (props) => {
    const { informationModalData, setInformationModalData } = useContext(InformationContext);

    const { areTileItemsHovered } = props;
    const cardRef = useRef();
    const [leftButtonVisible, setLeftButtonVisible] = useState(false);
    const [rightButtonVisible, setRightButtonVisible] = useState(false);
    const handleScrollLeft = () => {
        if (cardRef?.current) {
            const containerWidth = cardRef?.current?.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft -= scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScrollRight = () => {
        if (cardRef?.current) {
            const containerWidth = cardRef?.current?.offsetWidth;
            const scrollDistance = containerWidth * 0.75;
            cardRef.current.scrollLeft += scrollDistance; // adjust the scroll distance as needed
        }
    }
    const handleScroll = (event) => {
        const container = event?.target;
        const scrollPosition = container?.scrollLeft;
        const maxScrollLeft = container?.scrollWidth - container?.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }
    useEffect(() => {
        const container = cardRef?.current;
        const scrollPosition = container?.scrollLeft;
        const maxScrollLeft = container?.scrollWidth - container?.clientWidth;
        const reachedLeftEnd = scrollPosition === 0;
        const reachedRightEnd = scrollPosition === maxScrollLeft;
        setLeftButtonVisible(!reachedLeftEnd);
        setRightButtonVisible(!reachedRightEnd);
    }, []);

    return (
        <TeacherCardsContainer ref={cardRef} onScroll={handleScroll}>
            {areTileItemsHovered && leftButtonVisible &&
                <HorizontalScrollLeftButton onClickFunction={handleScrollLeft} />
            }
            {renderCardsList(props, setInformationModalData)}
            {areTileItemsHovered && rightButtonVisible &&
                <HorizontalScrollRightButton onClickFunction={handleScrollRight} />
            }
        </TeacherCardsContainer>
    )
}

export default TeacherCards;
